/* eslint-disable */
import React from 'react'
import styled from 'styled-components'
import { Checkbox as AntdCheckbox } from 'antd'

const StyledCheckbox = styled(AntdCheckbox)`
  padding-top: ${props => (props.color ? '10px' : '12px')};

  .ant-checkbox + span {
    padding-left: 12px;
  }
    
`
const LabelWrapper = styled.div`
  font-family: 'Plus Jakarta Sans';
  font-weight: ${props => (props.weight ? props.weight : 400)}; 
  font-size: 14px;
  line-height: 20px;
  color:  ${props => (props.color ? props.color : '#343e59')}; 
`

const Checkbox = ({ onChange, label, value, ...rest }) => {
  return (
    <StyledCheckbox {...rest} onChange={onChange} value={value}>
      <LabelWrapper {...rest}>{label}</LabelWrapper>
    </StyledCheckbox>
  )
}
export default Checkbox
